<template>
    <div class="show-cart-container" :class="{'visible': visible}" @click="toggleCartVisibility()">
        <div class="products-counter">{{ productsCounter }}</div>
        <img :src="shopping_cart_white">
    </div>
</template>

<script>

import CartController from '@/assets/controllers/CartController'
import eventModule from '@/assets/libs/eventModule'

export default {
    name: 'ShowCart',
    components: {

    },
    data () {
        return {
            shopping_cart_white: require('../../static/icons/shopping_cart_white.svg'),
            productsCounter: 0,
            visible: false
        }
    },
    created () {
        this.productsCounter = CartController.getCart().length
        eventModule.$on('refreshProductsCounter', this.refreshProductsCounter)
        setTimeout(() => {
            this.visible = true
        }, 200)
    },
    beforeDestroy () {
        eventModule.$off('refreshProductsCounter', this.refreshProductsCounter)
    },
    methods: {
        toggleCartVisibility: function () {
            this.$emit('toggleCartVisibility')
        },
        refreshProductsCounter: function () {
            this.productsCounter = CartController.getCart().length
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .show-cart-container {
        width: 100px;
        height: 100px;
        // border-radius: 100%;
        border-top-left-radius: 100%;
        border-top-right-radius: 100%;
        border-bottom-left-radius: 100%;
        background-color: @primary-color;
        position: absolute;
        bottom: 200px;
        right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        // transform: rotate(45deg);
        animation: ballon 3s infinite;
        opacity: 0;
        transition: all ease-in-out .3s;
        &.visible {
            opacity: 1;
        }
        img {
            width: 80px;
            height: 60px;
            transform: rotate(-45deg);
        }

        .products-counter {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: @primary-dark;
            color: @white;
            font-size: 25px;
            width: 40px;
            height: 40px;
            border-radius: 100%;
            position: absolute;
            top: -30px;
            left: 30px;
            transform: rotate(-45deg);
        }
    }
    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .show-cart-container {
            width: 70px;
            height: 70px;
            bottom: 170px;
            img {
                width: 50px;
                height: 40px;
            }
            .products-counter {
                font-size: 15px;
                width: 25px;
                height: 25px;
                top: -15px;
                right: -5px;
            }
        }
    }
    @media (max-width: 698px) { // Gertec SK210
        .show-cart-container {
            width: 50px;
            height: 50px;
            bottom: 120px;
            img {
                width: 40px;
                height: 30px;
            }
            .products-counter {
                font-size: 12px;
                width: 20px;
                height: 20px;
                top: -5px;
                right: -5px;
            }
        }
    }
    @keyframes ballon {
        0% {
            transform: translateY(10px) rotate(45deg);
        }
        50% {
            transform: translateY(0) rotate(45deg);
        }
        100% {
            transform: translateY(10px) rotate(45deg);
        }
}
@media (orientation: landscape) {
    .show-cart-container {
            width: 70px;
            height: 70px;
            bottom: 100px;
            img {
                width: 50px;
                height: 40px;
            }
            .products-counter {
                font-size: 15px;
                width: 25px;
                height: 25px;
                top: -15px;
                right: -5px;
            }
        }
}

</style>



// WEBPACK FOOTER //
// src/components/ShowCart.vue